import {
  TableCell } from '@mui/material';
import useStyles from './styles';

export const ProductionUserCell = ({ children, trim }) => {
  const { cell } = useStyles();
  const style = trim ? { width: '2em' } : null;
  return <TableCell className={cell} style={style}>{children}</TableCell>;
};
